import React from 'react'
import { DialogOverlay, DialogOverlayFooter, DialogOverlayActions, Button, Paragraph } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'

export default function ConfirmDeleteKiosk({ handleDeleteKiosk, ...overlay }) {
  const { t } = useTranslation()

  return (
    <DialogOverlay id="confirmDeleteKiosk" {...overlay} title={t('temple.kiosk.confirmRemove', 'Confirm Remove')}>
      <Paragraph size="sm">
        {t('temple.kiosk.removeConfirmation', 'Are you sure you want to delete this kiosk?')}
      </Paragraph>
      <DialogOverlayFooter>
        <DialogOverlayActions>
          <Button id="confirmDeleteKioskBtn" onClick={handleDeleteKiosk} type="submit" emphasis="high">
            {t('action.confirm', 'Confirm')}
          </Button>
          <Button id="cancelDeleteKioskBtn" onClick={() => overlay.close()}>
            {t('action.cancel', 'Cancel')}
          </Button>
        </DialogOverlayActions>
      </DialogOverlayFooter>
    </DialogOverlay>
  )
}
